const round2Chars = (value: number) => value.toString().padStart(2, '0');

export default round2Chars;
